__turbopack_context__.v({
  "page-top-skeleton": "iC0HYq_page-top-skeleton",
  "page-top-skeleton-tabs-section": "iC0HYq_page-top-skeleton-tabs-section",
  "page-top-skeleton-tabs-section__tab": "iC0HYq_page-top-skeleton-tabs-section__tab",
  "page-top-skeleton__button": "iC0HYq_page-top-skeleton__button",
  "page-top-skeleton__heading": "iC0HYq_page-top-skeleton__heading",
  "page-top-skeleton__text": "iC0HYq_page-top-skeleton__text",
  "tab-panel-skeleton": "iC0HYq_tab-panel-skeleton",
  "tab-panel-skeleton__heading": "iC0HYq_tab-panel-skeleton__heading",
  "tab-panel-skeleton__question": "iC0HYq_tab-panel-skeleton__question",
  "tab-panel-skeleton__slider": "iC0HYq_tab-panel-skeleton__slider",
  "tab-panel-skeleton__text": "iC0HYq_tab-panel-skeleton__text",
});
